export default __webpack_public_path__ + "static/media/EAST1000.34I-33305_-18309_0.acd46630.jpg";